import * as React from 'react';
import classNames from 'classnames';
import { NewbuildingRecommendation } from '../NewbuildingRecommendation';
import { OfferRecommendation } from '../OfferRecommendation';
import * as styles from './Recommendations.css';
export var Recommendations = function Recommendations(_ref) {
  var disabled = _ref.disabled,
    recommendations = _ref.recommendations;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles['recommendations-list'], disabled && styles['recommendations-list__disabled']),
    "data-testid": "recommendations-list"
  }, recommendations.map(function (recommendation) {
    switch (recommendation.type) {
      case 'offer':
        return /*#__PURE__*/React.createElement("div", {
          key: recommendation.realtyId,
          className: styles['recommendations-item']
        }, /*#__PURE__*/React.createElement(OfferRecommendation, {
          recommendation: recommendation
        }));
      case 'newbuilding':
        return /*#__PURE__*/React.createElement("div", {
          key: recommendation.newbuildingId,
          className: styles['recommendations-item']
        }, /*#__PURE__*/React.createElement(NewbuildingRecommendation, {
          recommendation: recommendation
        }));
      default:
        return null;
    }
  }));
};